import { useEffect } from "react";

export function createPlaceholder(estLineHeight, lineNo) {
	const linePlaceholder = document.createElement("div");
	linePlaceholder.style.height = `${estLineHeight}px`;
	linePlaceholder.id = `line-placeholder-${lineNo}`;
	linePlaceholder.className = "line-placeholder";
	linePlaceholder.innerHTML = '<div class="line-placeholder-loader"></div>';
	linePlaceholder.dataset.lineNo = lineNo;
	return linePlaceholder;
}

export function buildOverview({ estLineHeight, lineCount }, overview, start) {
	overview.innerHTML = "";

	let placeholder;

	Array.from({ length: lineCount }).forEach((_, lineNo) => {
		const linePlaceholder = createPlaceholder(estLineHeight, lineNo);
		if (start === lineNo) placeholder = linePlaceholder;
		overview.appendChild(linePlaceholder);
	});

	return placeholder;
}

export function useResizingEffect(
	overviewRef,
	scrollRef,
	baseRef,
	lineHeightData,
) {
	useEffect(() => {
		if (overviewRef.current == null || lineHeightData == null) {
			return;
		}

		const overview = overviewRef.current;
		const scroller = scrollRef.current;
		const start = Math.floor(baseRef.current / lineHeightData.length);
		const placeholder = buildOverview(lineHeightData, overview, start);

		if (placeholder) {
			scroller.scroll(0, placeholder.offsetTop - overview.offsetTop);
		}
	}, [lineHeightData, overviewRef.current, scrollRef.current]);
}
